export default __webpack_public_path__ + "static/media/check-solid-red.ba303ab1.svg";